import classNames from 'classnames'

interface IProps {
  children: any
  type?: 'button' | 'div'
  classes?: string
  active: boolean
  activeClasses?: string
  nonActiveClasses?: string
  callback?: () => void
}

export const ButtonTab: React.FC<IProps> = ({ children, type = 'button', classes, active, activeClasses, nonActiveClasses, callback }) => (
  <>
    {type === 'button' && (
      <button
        type='button'
        onClick={() => {
          if (callback) {
            callback()
          }
        }}
        className={classNames(
          classes,
          'px-[10px] py-[2px] sm:px-[20px] sm:py-[7.5px] h-[30px] sm:h-auto rounded-3xl jost-light text-[0.8em] sm:text-[0.9em] flex items-center justify-center gap-[5px] sm:gap-[8px] border border-border',
          active && (activeClasses || 'action-info'),
          !active && (nonActiveClasses || 'action-neutral')
        )}
      >
        {children}
      </button>
    )}
    {type === 'div' && (
      <div
        onClick={() => {
          if (callback) {
            callback()
          }
        }}
        className={classNames(
          classes,
          'px-[10px] py-[2px] sm:px-[20px] sm:py-[7.5px] h-[30px] sm:h-auto rounded-3xl jost-light text-[0.8em] sm:text-[0.9em] flex items-center justify-center gap-[5px] sm:gap-[8px] border border-border',
          active && (activeClasses || 'action-info'),
          !active && (nonActiveClasses || 'action-neutral')
        )}
      >
        {children}
      </div>
    )}
  </>
)
